import { urlCombine } from 'BASE/common/util/util.apiProxy';
import _constant from 'BASE/common/lotteryConstant';
export const GoogleAuthenticatorItemConst = _constant.GoogleAuthenticatorItem;
export const SetGoogleAuthenticatorWithItemResult = _constant.SetGoogleAuthenticatorWithItemResult;

export default {
    name: 'SecurityCenter',
    data: function () {
        return {
            GoogleAuthenticatorItemConst: GoogleAuthenticatorItemConst,
            LoginRecord: {
                LoginIPAddress: "",     //登入IP
                LoginDate: "",          //登入時間
                SourceURL: "",           //來源網址
                Country: "",             //國家
                County: "",              //縣
                Province: "",            //省
            },
            LastLoginIP: "",             //最後登入ip
            LastLoginTime: "",           //最後登入時間
            pswUpdateDate: "",           //最後修改密碼時間
            pswUsedDays: 0,              //密碼使用天數
            CreateTime: "",               //創建時間

            HeadImgUrl: "",
            LoginID: "",
            NickName: "",
            IsAgent: false,
            Email: "",
            PhoneNumber: "",
            BirthDay: "",
            QQNumber: "",
            WeChatNumber: "",
            ShiShiCaiOdds: 0,
            LayerName: "",
            Greetings: "",

            IsChangePassword: false,
            IsBindingWeChat: false,
            IsWechatDefaultPwd: false,

            TelegramInfo: {
                Id: "",
                BindTime: "",
                IsBinding: false,
            },

            BankCardCount: 0,

            AuthQuestionCount: 0,
            AuthAnswers: [],
            AuthQuestionList: [],

            IsEnableCheckIP: false,

            IsEnableGoogleAuthenticator: false,
            googleAuthModel: {
                SecretKey: "",
                BarcodeUrl: ""
            },

            WeChatUrlList: "",           //後台微信推廣所有設定網址
            FriendRegisterLink: "",       //好友推廣代碼

            SecurityCenterConfig: {
                SecurityNickName: false,
                SecurityPassword: false,
                SecurityDrawPassword: false,
                SecurityAuthQuestion: false,
                SecurityWechatBinding: false,
                SecurityQQNumber: false,
                SecurityEmail: false,
                SecurityPhoneNumber: false,
                SecurityBirthDay: false,
                SecurityGreetings: false,
                SecurityCheckIP: false,
                SecurityGoogleAuth: false,
                SecurityWechatNumber: false,
                SecurityHeadImgae: false,
                SecurityBetPassword: false,
            },
            initfinish: false,
            GoogleAuthenticatorItem: 0,
            IsLoginWithGoogleAuth: false,
            IsLoginWithGesture: false,
            IsGesturePasswordExists: false,

            IsDrawPasswordSet: false,
            HeadImage_type: 0,
            //init後密碼規則依照後端配置替換
            PasswordRegular: {
                Rule: '',
                Placeholder: "",
                ErrorMsg: "",
            },
            UserReturnPoint: 0,
            IsBetPasswordSet: false,
            IsBetPwdDisable: false,
            UserDefinedGoogleAuthItems:{
                IsGoogleAuthLogin: false,
                IsGoogleAuthChangePwd: false,
                IsGoogleAuthChangeDrawPwd: false,
                IsGoogleAuthTransfer: false,
                IsGoogleAuthWithdraw: false,
            },
        };
    },
    computed: {
        NickNameOrDefault: function () {
            let _this = this;

            return _this.NickName || _this.LoginID || "";
        },
        AccountType: function () {
            let _this = this;

            return _this.IsAgent ? "代理" : "会员";
        },
        isWeChatEnabled() {
            return this.$store.state.userinfo.isWeChatEnabled;
        },
        isTransferPointEnabled() {
            return this.$store.state.userinfo.privileges.isTransferPointEnabled;
        },
    },
    filters: {
        StrEmptyReplace: function (value, ReplaceStr) {
            return typeof value === "undefined" || value == "" || value == "N/A" ? ReplaceStr : value;
        },
        urlCombine: function (value) {
            return urlCombine(value);
        }
    },
    methods: {
        AutoMapping(fromObj, ToObj) {
            let _this = this;

            for (let key in ToObj) {
                if (key in fromObj && !!fromObj[key] && typeof ToObj[key] == typeof fromObj[key]) {
                    if (typeof ToObj[key] == "object" && !Array.isArray(ToObj[key])) {
                        _this.AutoMapping(fromObj[key], ToObj[key]);
                    } else {
                        ToObj[key] = fromObj[key];
                    }
                }
            }
        },
        async InitData() {
            let _this = this;
            try {
                let result = await $.postJSON(_this.$ApiUrlManager.GetSecurityCenterData);
                _this.AutoMapping(result, _this);
                _this.initfinish=true;
                _this.PasswordRegular = {
                    Rule: result.PlayerPasswordRegularExpression,
                    Placeholder: result.PlayerPasswordPlaceholder,
                    ErrorMsg: result.PlayerPasswordErrorMsg
                };
            }
            catch (err) {
                console.error(err);
                _this.$dialog.warning("页面载入失败，请稍后重试!");
            }
        },
        SettingBlockChange(component, toggle) {
            //各 children 按下設定後會呼叫此method
        },

        showComponetDialog(dialogName) {
            let ref = this.$refs[dialogName];

            if (ref != null && typeof ref.SettingClickEvent == "function")
                ref.SettingClickEvent();
        },

        ToggleDialog(dialogName, toggle) {
            let _dialog = this.$dialog.get(dialogName);

            if (_dialog) {
                if (toggle)
                    _dialog.show();
                else
                    _dialog.hide();
            }
        },
        TriggerChildrenSettingkEvent(name) {
            let children = this.$children.find((c) => {
                return c.$options.name == name;
            });

            if (typeof children === "undefined" || typeof children.SettingClickEvent != "function") return;

            children.SettingClickEvent();
        },
        async CheckGooglePasswordAndSetGoogleAuthenticatorWithItem( LoginID, GooglePassword, GoogleAuth, type ) {
            try {
                var model = {
                    LoginID: LoginID,
                    GooglePassword: GooglePassword,
                    GoogleAuth: !GoogleAuth,
                    type: type
                }
                let _respond = await $.postJSON(`/api/AccountCenter/CheckGooglePasswordAndSetGoogleAuthenticatorWithItem/`, model);
                if (_respond.result == SetGoogleAuthenticatorWithItemResult.SUCCESS) {
                    switch( type ){                        
                        case GoogleAuthenticatorItemConst.ChangePassword:
                            this.UserDefinedGoogleAuthItems.IsGoogleAuthChangePwd = model.GoogleAuth;
                            break;
                        case GoogleAuthenticatorItemConst.ChangeDrawPassword:
                            this.UserDefinedGoogleAuthItems.IsGoogleAuthChangeDrawPwd = model.GoogleAuth;
                            break;
                        case GoogleAuthenticatorItemConst.TransferPoint:
                            this.UserDefinedGoogleAuthItems.IsGoogleAuthTransfer = model.GoogleAuth;
                            break;
                        case GoogleAuthenticatorItemConst.Withdraw:
                            this.UserDefinedGoogleAuthItems.IsGoogleAuthWithdraw = model.GoogleAuth;
                            break;
                        case GoogleAuthenticatorItemConst.Login:
                            this.UserDefinedGoogleAuthItems.IsGoogleAuthLogin = model.GoogleAuth;     
                            break;                   
                    }
                }
                return _respond;
            }
            catch (err) {
                console.error(err);
            }
        },     
        async SetGoogleAuthenticatorWithItem( GoogleAuth, type ) {
            try {
                var model = { GoogleAuth: !GoogleAuth, type: type };
                let _respond = await $.postJSON(`/api/AccountCenter/SetGoogleAuthenticatorWithItem/`, model);
                if (_respond.state) {
                    switch( type ){                        
                        case GoogleAuthenticatorItemConst.ChangePassword:
                            this.UserDefinedGoogleAuthItems.IsGoogleAuthChangePwd = model.GoogleAuth;
                            break;
                        case GoogleAuthenticatorItemConst.ChangeDrawPassword:
                            this.UserDefinedGoogleAuthItems.IsGoogleAuthChangeDrawPwd = model.GoogleAuth;
                            break;
                        case GoogleAuthenticatorItemConst.TransferPoint:
                            this.UserDefinedGoogleAuthItems.IsGoogleAuthTransfer = model.GoogleAuth;
                            break;
                        case GoogleAuthenticatorItemConst.Withdraw:
                            this.UserDefinedGoogleAuthItems.IsGoogleAuthWithdraw = model.GoogleAuth;
                            break;
                        case GoogleAuthenticatorItemConst.Login:
                            this.UserDefinedGoogleAuthItems.IsGoogleAuthLogin = model.GoogleAuth;     
                            break;                   
                    }
                }
            }
            catch (err) {
                console.error(err);
            }
        },        
    },
    async mounted() {
        await this.InitData();

    },
    updated() {
        for (let c of this.$children) {
            if (typeof c.$options.name !== "undefined") {
                c.$on('SettingBlockChange', this.SettingBlockChange);
                c.$on('ToggleDialog', this.ToggleDialog);
            }
        }
    }
};